export const en = {
    'amnesty-price': 'Click price',
    'amnesty-price-with-currency': 'Click price, {currency}',
    banners: 'Ads',
    'campaign-group': 'Campaign/group',
    'campaign-type': 'Campaign type',
    'context-price': 'Bid (in ad networks)',
    'context-price-cpm': 'CPM bid',
    'context-price-with-currency': 'Bid (in ad networks), {currency}',
    'context-price-with-currency-cpm-banner': 'CPM bid, {currency}',
    coverage: 'Coverage',
    'coverage-with-percent': 'Coverage, %',
    ectr: 'eCTR',
    phrase: 'Keywords',
    price: 'Bid',
    'price-with-currency': 'Bid, {currency}',
    priority: 'Priority',
    status: 'Status',
    'traffic-forecast': 'Traffic forecast'
};
